import ScheduleDefinitionSchedulingStrategyEditor from "../../../pages/actionModules/ActionModuleEditor/SchedulingStrategyEditor/ScheduleDefinitionSchedulingStrategyEditor";
import { SchedulingStrategyDefinition } from "../actionModule";
import { DayOfWeek, ScheduleDaysDefinition, ScheduleDefinitionType, SchedulingStrategyType } from "./schedulingStrategyType";

export const ScheduleDefinitionSchedulingStrategy: SchedulingStrategyDefinition = {
    name: "actionModules.schedulingStrategy.scheduleDefinition.name",
    defaultValue: {
        scheduleDefinition: {
            combineConsecutiveDays: false,
            discriminator: ScheduleDefinitionType.Day,
            startDate: null,
            endDate: null,
            separateByMonth: false,
            separateByWeek: false,
            days: [
                {
                    dayOfWeek: DayOfWeek.Monday,
                    startTime: null,
                    endTime: null
                },
                {
                    dayOfWeek: DayOfWeek.Tuesday,
                    startTime: null,
                    endTime: null
                },
                {
                    dayOfWeek: DayOfWeek.Wednesday,
                    startTime: null,
                    endTime: null
                },
                {
                    dayOfWeek: DayOfWeek.Thursday,
                    startTime: null,
                    endTime: null
                },
                {
                    dayOfWeek: DayOfWeek.Friday,
                    startTime: null,
                    endTime: null
                },
            ],
        } as ScheduleDaysDefinition,
    },
    type: SchedulingStrategyType.ScheduleDefinitionSchedulingStrategy,
    editor: (props) => <ScheduleDefinitionSchedulingStrategyEditor {...props} />
};